var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAppstore = function SvgAppstore(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "w6ppfg3hwa",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#009AFD"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#w6ppfg3hwa)",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.662 11.647c.394 0 .638.098.862.212.176.09.31.199.36.241.011.01.014.029.007.043l-.727 1.388c-.157.3-.445.469-.741.469-.143 0-.287-.04-.42-.121-.41-.254-.543-.847-.31-1.293l.272-.518c.068-.13.166-.237.287-.307.104-.061.243-.114.41-.114zm5.212-4.687c.02-.027.058-.024.073.005l1.83 3.476h1.525c.386 0 .698.34.698.758s-.312.758-.698.758h-.728l.479.91c.19.362.074.825-.26 1.033-.11.068-.228.1-.346.1-.242 0-.478-.137-.606-.382l-.875-1.661-.797-1.516-.644-1.224c-.176-.333-.186-.737-.116-1.195.045-.297.129-.545.243-.73.072-.116.164-.25.222-.332zM8.136 4.099c.355-.206.806-.08 1.008.28l.224.398.199-.353c.202-.36.654-.485 1.008-.28.354.206.477.665.275 1.025l-.63 1.121-.852 1.514-1.316 2.342H9.8c.25 0 .54.043.716.27.176.226.238.442.238.706 0 .263-.015.525-.456.525h-5.56c-.407 0-.738-.336-.738-.75 0-.415.33-.751.739-.751h1.61L8.519 6.29 7.86 5.123c-.202-.36-.079-.818.275-1.024z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAppstore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "appstore.f53819bac946e8c7c7e1d9314d74f01f.svg";